import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import { endpoints } from "../endpoints";
import * as gatewayAndPriceListRCSActions from "../actions/gateway_and_price_list_rcs_actions";
import * as gatewayAndPriceListRCSTypes from "../types/gateway_and_price_list_rcs_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";

function* getListOfRCSPrice(action) {
  try {
    const res = yield call(api.get, endpoints.SUPER_ADMIN_RCS_PRICE, action.payload);
    if (res.status === 200) {
      yield put(gatewayAndPriceListRCSActions.getListOfRCSPriceSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(gatewayAndPriceListRCSActions.getListOfRCSPriceError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(gatewayAndPriceListRCSActions.getListOfRCSPriceError(e));
  }
}

function* editRCSPrice(action) {
  try {
    const res = yield call(api.patch, `${endpoints.SUPER_ADMIN_RCS_PRICE}/${action.payload.id}`, action.payload.data);
    if (res.status === 200) {
      yield put(gatewayAndPriceListRCSActions.editRCSPriceSuccess(res.data));
      yield put(gatewayAndPriceListRCSActions.getListOfRCSPriceRequest(action.payload.loadingData));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(gatewayAndPriceListRCSActions.editRCSPriceError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(gatewayAndPriceListRCSActions.editRCSPriceError(e));
  }
}


export default function* gatewayAndPriceListRCSSaga() {
  yield takeLatest(gatewayAndPriceListRCSTypes.getListOfRCSPrice.GET_LIST_OF_RCS_PRICE_REQUEST, getListOfRCSPrice);
  yield takeLatest(gatewayAndPriceListRCSTypes.editRCSPrice.EDIT_RCS_PRICE_REQUEST, editRCSPrice);
}
